import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/cart-with-box-outline-blue.svg'


const _hoisted_1 = { class: "master-new-form container-hjp-confirm-modal" }
const _hoisted_2 = { class: "py-4 flex items-center gap-4 justify-between border-bottom-grey-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Informasi Partner")
], -1)
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Aktif", -1)
const _hoisted_6 = { class: "pt-4" }
const _hoisted_7 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Nama Partner"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Nama pom bensin yang menjadi partner")
], -1)
const _hoisted_9 = { class: "col-span-2" }
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Kode"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Penulisan kode maksimal 3 huruf")
], -1)
const _hoisted_13 = { class: "col-span-2" }
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Setting Desimal (Koma)"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Jumlah angka di belakang koma yang dijadikan acuan tiap pom (Nilai max = 9)")
], -1)
const _hoisted_17 = { class: "col-span-2" }
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Rekening"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Data rekening partner SPBU untuk pembayaran bon BBM")
], -1)
const _hoisted_21 = { class: "col-span-2" }
const _hoisted_22 = { class: "grid grid-cols-1 md:grid-cols-5 gap-4" }
const _hoisted_23 = { class: "invalid-feedback" }
const _hoisted_24 = { class: "col-span-2" }
const _hoisted_25 = { class: "invalid-feedback" }
const _hoisted_26 = { class: "col-span-2" }
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Kota"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Kota lokasi partner")
], -1)
const _hoisted_30 = { class: "col-span-2" }
const _hoisted_31 = { class: "invalid-feedback" }
const _hoisted_32 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Alamat"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Alamat pom bensin partner")
], -1)
const _hoisted_34 = { class: "col-span-2" }
const _hoisted_35 = { class: "invalid-feedback" }
const _hoisted_36 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Maps"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Titik maps lokasi partner")
], -1)
const _hoisted_38 = { class: "col-span-2" }
const _hoisted_39 = {
  key: 0,
  class: "w-full py-2 px-3 border-grey-3 rounded-lg flex items-center justify-between gap-4"
}
const _hoisted_40 = { class: "text-primary font-semibold text-sm items-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "text-sm text-primary pi pi-map-marker" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-pencil text-grey text-sm" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Ubah Lokasi ")
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-primary" }, /*#__PURE__*/_toDisplayString("Buka Maps"), -1)
const _hoisted_46 = { class: "invalid-feedback" }
const _hoisted_47 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Username Login"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Username yang nanti bisa login ke web dan aplikasi partner")
], -1)
const _hoisted_49 = { class: "col-span-2" }
const _hoisted_50 = { class: "invalid-feedback" }
const _hoisted_51 = { class: "flex items-center justify-end mt-4" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Simpan")
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "flex items-center justify-end gap-4 mt-4" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('Pilih'))
const _hoisted_57 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('Kembali'))

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import SelectAsyncOpen from '@/views/components/form/SelectAsyncOpen.vue'
import Button from 'primevue/button'
import Card from 'primevue/card'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import { Field, useForm } from 'vee-validate'
import { getCurrentInstance, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import * as Yup from 'yup'
import apiUseCase from '@/usecase/apiUseCase'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import geohash from 'latlon-geohash'
import InputSwitch from 'primevue/inputswitch'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import MapsSearch from '../city-terminal/components/MapsSearch.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const backRouteName = 'master-spbu'
const endpoint = '/management/v2/FuelStationPartners'
const extrnalAuthUserEndpoint = 'talent/v1/externalAuth/users'

const store = useStore()
const route = useRoute()
const router = useRouter()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const idPrams = ref(null) as any
const isShowMap = ref(false)
const mapAddress = ref('')
const mapAddressTemp = ref('')
const mapData = ref({
  lat: '',
  lng: ''
}) as any

const initialValues = ref({
  name: null as any,
  code: null as any,
  city: null as any,
  address: null as any,
  maps: null as any,
  usernameSso: null as any,
  bank: null as any,
  bankAccount: null as any,
  bankUsername: null as any,
  decimalSetting: null as any,
  isActive: true
})

const schema = Yup.object().shape({
  name: Yup.string()
    .required('Nama Partner harus diisi')
    .min(3, 'Nama Partner minimal 3 karakter')
    .max(100, 'Nama Partner maksimal 100 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Partner tidak boleh hanya menggunakan spasi')
    .test('unique-type', 'Nama Partner sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (idPrams.value?.Id) {
          return filterResult.length === 0 || val === initialValues.value.name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  code: Yup.string()
    .min(2, 'Kode Partner minimal 2 karakter')
    .max(3, 'Kode Partner maksimal 3 karakter')
    .matches(rgxExp.notPrefixSpace, 'Kode Partner tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.notOnlySpecialChar, 'Kode Partner hanya boleh menggunakan huruf, angka, - dan _')
    .test('unique-type', 'Kode Partner sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Code === val)
        if (idPrams.value?.Id) {
          return filterResult.length === 0 || val === initialValues.value.code
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    })
    .required('Kode Partner harus diisi'),
  decimalSetting: Yup.number()
    .typeError('Setting desimal harus berupa angka')
    .required('Setting desimal harus diisi')
    .integer('Setting desimal harus berupa bilangan bulat')
    .min(0, 'Setting desimal minimal 0')
    .max(9, 'Setting desimal maksimal 9'),
  bank: Yup.object()
    .required('Bank harus diisi'),
  bankAccount: Yup.string()
    .required('Nomor Rekening harus diisi')
    .matches(/^\d+$/, 'Nomor Rekening hanya boleh berisi angka')
    .min(8, 'Nomor Rekening minimal 8 digit')
    .max(30, 'Nomor Rekening maksimal 30 digit'),
  bankUsername: Yup.string()
    .required('Nama Rekening harus diisi')
    .min(3, 'Nama Rekening minimal 3 karakter')
    .max(100, 'Nama Rekening maksimal 100 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Rekening tidak boleh hanya menggunakan spasi'),
  city: Yup.object().required('Kota Partner harus diisi'),
  address: Yup.string()
    .min(10, 'Alamat minimal 10 karakter')
    .max(255, 'Alamat maksimal 255 karakter')
    .matches(rgxExp.notPrefixSpace, 'Alamat tidak boleh hanya menggunakan spasi')
    .required('Alamat harus diisi'),
  usernameSso: Yup.object().required('Username Login harus diisi'),
  maps: Yup.object().required('Titik maps harus diisi')
})

const { values, errors, setFieldValue, handleSubmit, resetForm } = useForm({
  initialValues,
  validationSchema: schema
})

const onlyNumberBankAccount = (event: Event) => {
  const target = event.target as HTMLInputElement
  const value = target.value.replace(/\D/g, '')

  target.value = value
  setFieldValue('bankAccount', value)
}

const openMapsDialog = () => {
  isShowMap.value = true
  mapAddressTemp.value = ''
  // mapData.value = { lat: '', lng: '' }
  // console.log('maps', isShowMap.value ? 'true' : 'false')
}

const closeMapsDialog = () => {
  isShowMap.value = false
  // console.log('maps', isShowMap.value ? 'true' : 'false')
}

const onDialogMapSubmit = () => {
  isShowMap.value = false
  // console.log('mapData', mapData.value)
  setFieldValue('maps', mapData.value)
  mapAddress.value = mapAddressTemp.value
  // dataForm.address = mapData.value?.selectedLocation
  // dataForm.Latitude = mapData.value?.lat
  // dataForm.Longitude = mapData.value?.lng
}

const getLocationFromMaps = (val: any) => {
  mapAddressTemp.value = val.formatted_address
  mapData.value = { lat: val.latLng.lat().toString(), lng: val.latLng.lng().toString() }
  // console.log('address', mapAddressTemp.value)
}

const closeMapDialog = () => {
  isShowMap.value = false
  mapAddressTemp.value = ''
  // mapData.value = { lat: '', lng: '' }
}

const toPrevPage = () => {
  router.push({
    name: backRouteName
  })
}

const processSubmit = async (payload: any) => {
  store.dispatch('showLoading')
  try {
    await apiUseCase.postOrPut(`${endpoint}`, idPrams.value?.Id, payload).then((response) => {
      const { result, error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: 'Partner SPBU berhasil disimpan',
          group: 'bc',
          life: 3000
        })
        // eslint-disable-next-line no-use-before-define
        toPrevPage()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal menyimpan Partner SPBU',
          detail: message,
          group: 'bc',
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal menyimpan Partner SPBU',
      detail: error,
      group: 'bc',
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onSubmit = handleSubmit((dataForm: any) => {
  // console.log('dataForm', dataForm)
  const geohashEncode = geohash.encode(dataForm.maps.lat, dataForm.maps.lng)
  // console.log('encode', geohashEncode)
  // console.log('dataForm', dataForm)
  const payload = {
    Name: dataForm.name ?? '-',
    Code: dataForm.code ?? '-',
    Address: dataForm.address ?? '-',
    CityId: dataForm.city.Id ?? '-',
    Geohash: geohashEncode ?? '-',
    IsActive: dataForm.isActive,
    AccountUserId: dataForm.usernameSso.id ?? '-',
    MsBankId: dataForm.bank.Id ?? '-',
    AccountNumber: dataForm.bankAccount ?? '-',
    AccountName: dataForm.bankUsername ?? '-',
    TransactionDecimalPlaces: dataForm.decimalSetting ?? 0
  }
  processSubmit(payload)
})

const getUsernameSsoData = async (id: string) => {
  const response = await apiOpenUseCase.get(`${extrnalAuthUserEndpoint}/${id}`)
  console.log('res', response)
  const data = response.result
  // const filteredRes = response.result.filter((data: any) => data.id === id)
  // // console.log('filteredRes', filteredRes[0])
  // return filteredRes.length > 0 ? { ...filteredRes[0], label: `${filteredRes[0].username} - ${filteredRes[0].firstName ?? ''} ${filteredRes[0].lastName ?? ''}` } : null
  return data ? { ...data, label: `${data.username} - ${data.firstName ?? ''} ${data.lastName ?? ''}` } : null
}

const getDataDetail = async () => {
  try {
    await apiUseCase.get(`${endpoint}/${idPrams.value?.Id}`).then(async (response) => {
      const { result } = response
      const authUserData = await getUsernameSsoData(result.AccountUserId)
      const coordinateTemp = geohash.decode(result.Geohash)
      // console.log('geo', coordinateTemp)
      console.log('res', result)
      initialValues.value = {
        name: result.Name,
        code: result.Code,
        isActive: result.IsActive,
        city: { Id: result.CityId, Name: result.CityName, label: result.CityName, value: result.CityId },
        address: result.Address,
        maps: { lat: coordinateTemp?.lat, lng: coordinateTemp?.lon },
        usernameSso: authUserData ?? null,
        bank: { Id: result.MsBankId, Name: result.MsBankName, label: result.MsBankName, value: result.MsBankId },
        bankAccount: result.AccountNumber ?? null,
        bankUsername: result.AccountName ?? null,
        decimalSetting: result.TransactionDecimalPlaces ?? 0
      }
      setFieldValue('isActive', result.IsActive)
      mapData.value = { lat: coordinateTemp?.lat, lng: coordinateTemp?.lon }
      console.log('map', mapData.value)
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal mengambil data Partner SPBU. Silahkan coba beberapa saat lagi.',
      detail: error,
      group: 'bc',
      life: 3000
    })
    toPrevPage()
  }
}

onMounted(() => {
  let editOrAdd = 'Tambah'
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    editOrAdd = 'Detail'
    getDataDetail()
  }
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Master Partner SPBU',
      routeName: backRouteName
    },
    {
      title: `${editOrAdd} Partner SPBU`,
      routeName: `${backRouteName}-form`,
      params: { id: route.params.id }
    }
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
    }, [
      _createVNode(_unref(Card), { lass: "card-no-shadow" }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_unref(InputSwitch), {
                class: "input-success",
                modelValue: _unref(values).isActive,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(values).isActive) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Field), { name: "name" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputText), {
                      id: "name",
                      modelValue: _unref(values).name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(values).name) = $event)),
                      placeholder: "Masukkan nama partner"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(errors).name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(Field), { name: "code" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputText), {
                      id: "name",
                      modelValue: _unref(values).code,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(values).code) = $event)),
                      maxlength: "3",
                      style: {"text-transform":"uppercase"},
                      placeholder: "Contoh: KLS"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(errors).code), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_unref(Field), { name: "decimalSetting" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputText), {
                      id: "decimalSetting",
                      modelValue: _unref(values).decimalSetting,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(values).decimalSetting) = $event)),
                      type: "number",
                      min: "0"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(errors).decimalSetting), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(Field), { name: "bank" }, {
                      default: _withCtx(() => [
                        _createVNode(SelectAsync, {
                          endpoint: "/management/v1/MsBank",
                          classname: "custom-select",
                          fieldLabel: (v) => v.Name,
                          searchFields: ['name'],
                          placeholder: 'Pilih Bank',
                          modelValue: _unref(values).bank,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(values).bank) = $event))
                        }, null, 8, ["fieldLabel", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(errors).bank), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(Field), { name: "bankAccount" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(InputText), {
                          id: "bankAccount",
                          modelValue: _unref(values).bankAccount,
                          onInput: onlyNumberBankAccount,
                          inputmode: "numeric",
                          placeholder: "Nomor Rekening"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(errors).bankAccount), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_unref(Field), { name: "bankUsername" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(InputText), {
                          id: "name",
                          modelValue: _unref(values).bankUsername,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(values).bankUsername) = $event)),
                          style: {"text-transform":"uppercase"},
                          placeholder: "Nama Rekening"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(errors).bankUsername), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_unref(Field), { name: "city" }, {
                  default: _withCtx(() => [
                    _createVNode(SelectAsync, {
                      endpoint: "/management/v1/MsCity",
                      classname: "custom-select",
                      fieldLabel: (v) => v.CityName,
                      searchFields: ['query'],
                      placeholder: 'Masukkan Kota',
                      modelValue: _unref(values).city,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(values).city) = $event))
                    }, null, 8, ["fieldLabel", "modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(errors).city), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_unref(Field), { name: "address" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Textarea), {
                      modelValue: _unref(values).address,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(values).address) = $event)),
                      rows: "5",
                      cols: "30",
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(errors).address), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_unref(Field), { name: "maps" }, {
                  default: _withCtx(() => [
                    (_unref(values).maps)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createTextVNode(" " + _toDisplayString(`(${_unref(values).maps.lat}, ${_unref(values).maps.lng})`), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "text-grey items-center text-grey text-sm cursor-pointer",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (openMapsDialog()))
                          }, _hoisted_44)
                        ]))
                      : (_openBlock(), _createBlock(_unref(Button), {
                          key: 1,
                          class: "flex gap-2 extra-submit-button p-3",
                          outlined: true,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (openMapsDialog()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(errors).maps), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_unref(Field), { name: "usernameSso" }, {
                  default: _withCtx(() => [
                    _createVNode(SelectAsyncOpen, {
                      placeholder: 'Pilih Username Login',
                      modelValue: _unref(values).usernameSso,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(values).usernameSso) = $event)),
                      id: 'usernameSso',
                      endpoint: "talent/v1/externalAuth/users",
                      classname: 'custom-select',
                      disabled: false,
                      fieldLabel: (v) => `${v.username} - ${v.firstName ?? ''} ${ v.lastName ?? ''}`,
                      clearable: false,
                      searchFields: ['username']
                    }, null, 8, ["modelValue", "fieldLabel"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(errors).usernameSso), 1)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (toPrevPage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_52
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                id: "Submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_53
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ], 32),
    _createVNode(_unref(Dialog), {
      visible: isShowMap.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((isShowMap).value = $event)),
      showHeader: true,
      style: { width: '50vw' },
      dismissableMask: false,
      modal: true
    }, {
      default: _withCtx(() => [
        (isShowMap.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _createVNode(MapsSearch, {
                onSendDataLocation: _cache[13] || (_cache[13] = (e) => {
          // setFieldValue('maps', { lat: e.latLng.lat().toString(), lng: e.latLng.lng().toString() })
          getLocationFromMaps(e)
        }),
                existLat: _unref(mapData).lat,
                existLng: _unref(mapData).lng
              }, null, 8, ["existLat", "existLng"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_55, [
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mb-2 md:mb-0",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (onDialogMapSubmit()))
          }, {
            default: _withCtx(() => [
              _hoisted_56
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (closeMapDialog()))
          }, {
            default: _withCtx(() => [
              _hoisted_57
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})